import { Box } from '@mui/material'
import CopyRight from './Copyright'
import TopFooter from './TopFooter'

export default function Footer() {
  return (
    <Box sx={{ width: '100%', mb: 5, padding: { xs: '40px 16px', md: '64px 112px' } }}>
      <TopFooter />
      <CopyRight />
    </Box>
  )
}
